import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
`

export const SubContainer = styled(Container)`
  width: 100%;
  padding: 0px;
  gap: 20px;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px;
`

export const FilterColumn = styled(Column)`
  padding: 0;
  width: 250px;

  @media (max-width: 576px) {
    width: 100%;
  }
`

export const Row = styled(Container)`
  width: 100%;
  padding: 0px;
  flex-direction: row;
  align-items: center;
  flex-wrap: wrap;
  gap: 3px;
`

export const LogoRow = styled(Row)`
  gap: 5px;
  margin-bottom: 20px;

  p {
    font-size: 16px;
  }
`

export const SchedulesGrid = styled.div`
  display: grid;
  gap: 15px;
  margin-top: 15px;

  @media (min-width: 768px) {
    width: ${({ total }) => total > 1 ? '768px' : '380px'};
    grid-template-columns: repeat(${({ total }) => total > 1 ? 2 : 1}, 1fr);
  }

  @media (max-width: 767px) {
    width: ${({ total }) => total > 1 ? '100%' : '380px'};
    grid-template-columns: repeat(${({ total }) => total > 1 ? 2 : 1}, 1fr);
  }

  @media (max-width: 480px) {
    width: 100%;
    grid-template-columns: repeat(1, 1fr);
  }
`

export const SmallImage = styled.img`
  width: 24px;
  height: 24px;
`

export const InfoText = styled.p`
  font-size: 14px;
  text-align: center;
  line-height: 18px;
  margin: 0px;
`

export const Title = styled(InfoText)`
  font-size: 18px;
  font-weight: 500;
  text-align: center;
`

export const SubTitle = styled(Title)`
  font-size: 14px;
  margin-bottom: 0px;
`

export const LinkText = styled.a`
  color: #35A7FF;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-decoration: none;
  gap: 3px;

  &:hover {
    color: #2875E2;
  }
`

export const WarningText = styled(InfoText)`
  color: #FF3939;
  margin-top: 2px;
`

export const ErrorContainer = styled.div`
  padding: 9px;
  margin-top: 15px;
  width: 100%;
  border-radius: 15px;
  align-items: center;
  background-color: #FF3939;
`
